import ArrowLink from "@/components/ui/arrow-link";
import { FC } from "react";
import S from "./index.module.scss";
import Image from "next/image";
import { DesignResource } from "@/api/generated-api";
import { useTranslations } from "next-intl";

const DesignerCard: FC<DesignResource> = ({ title, url, tags, description, image }) => {
  const t = useTranslations();

  return (
    <div className={S.cardWrapper}>
      <Image className={S.cardImage} src={image} alt="designer" width={660} height={320} />
      <div className={S.cardContent}>
        <h3 className={S.cardTitle}>{title}</h3>
        <span className={S.creators}>{tags?.join(", ")}</span>
        <span className={S.subtitle}>{description}</span>
        <ArrowLink url={url} text={t("website")} />
      </div>
    </div>
  );
};

export default DesignerCard;
